import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DefaultDataService } from '@ngrx/data';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';
import { CcoHttpUrlGenerator } from '@app/store/cco-http-url-generator';
import { GoogleCalendar } from '@modules/link-google-api/services/select-calendar-api.service';

@Injectable({
  providedIn: 'any'
})
export class GoogleCalendarDataService extends DefaultDataService<GoogleCalendar> {
  constructor() {
    const config = inject<AppConfig>(APP_CONFIG);
    const http = inject(HttpClient);
    const httpUrlGenerator = inject(CcoHttpUrlGenerator);

    super('GoogleCalendar', http, httpUrlGenerator, {
      root: config.cloudApiBaseUrl,
    });
  }
}
